var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CCol',{attrs:{"col":"12","sm":"6","lg":"3"}},[_c('CWidgetIcon',{attrs:{"header":_vm.numberOfUsers,"text":"Users on platform","color":"gradient-info"}},[_c('CIcon',{attrs:{"name":"cil-laptop","width":"24"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }